module.exports = {
  publicPath: process.env.STATIC_FILES_URL || '/adout/static/',
  axe: {
    // It was causing lag in the search box on li, we should rethink how we do react-axe checks
    enabled: false,
  },
  cpuCount: process.env.CPU_COUNT || 24,
  webpack: {
    node: {
      net: 'empty',
      tls: 'empty',
    },
  },
}
